import { VSpacer } from '@/components/DesignSystem';
import { getBrandColor } from '@/pages/CustomerDashboard/DashboardLayout';
import { EnergyPageFrame } from '@/pages/CustomerDashboard/Energy/EnergyPageFrame';
import { EnergyBehaviorItem } from '@/pages/CustomerDashboard/Energy/EnergyProgressSection';
import { EnergyTierCard } from '@/pages/CustomerDashboard/Energy/EnergyTierBenefitsModal';
import { getHasTierGraphics } from '@/pages/CustomerDashboard/helpers';
import { ApiEnergyDashboard } from '@api/interfaces/ApiEnergyDashboard';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EnergyBenefitsPageProps {
  accessToken: string,
  data: ApiEnergyDashboard,
}

export const EnergyBenefitsPage = ({ accessToken, data }: EnergyBenefitsPageProps) => {
  const { t } = useTranslation();
  const brandColor = getBrandColor(data.retailer);
  const currentRank = data.currentTier?.rank ?? -1;
  const hasTierGraphics = getHasTierGraphics(data.tiers.map(({ name }) => name));

  const badgeFor = (rank: number) => {
    if (rank === currentRank) {
      return t(($) => $.customerDashboard.energy.current);
    }
    return rank < currentRank ? t(($) => $.customerDashboard.energy.completed) : undefined;
  };

  return (
    <EnergyPageFrame
      accessToken={accessToken}
      brandColor={brandColor}
      testID="energy-benefits-page"
      title={t(($) => $.customerDashboard.benefits.title)}
    >
      <Stack gap="16px" p="20px 16px">
        {data.tiers.map((tier) => (
          <Stack key={tier.rank}>
            <EnergyTierCard
              badge={badgeFor(tier.rank)}
              brandColor={brandColor}
              hasTierGraphics={hasTierGraphics}
              tier={tier}
            />
            {data.behaviors
              .filter(({ tierRank }) => tierRank === tier.rank)
              .map((behavior) => (
                <Stack bgcolor="white" key={behavior.id} px="16px">
                  <EnergyBehaviorItem behavior={behavior} />
                </Stack>
              ))}
          </Stack>
        ))}
      </Stack>
      <VSpacer size="8" />
    </EnergyPageFrame>
  );
};
